import styles from '../App.module.css';
import { Mascot } from './mascots';
import { useLanguage } from '../i18n/context';
import { getUi } from '../i18n/ui';

export function Disclaimer() {
  const { locale } = useLanguage();
  const ui = getUi(locale);

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <p className={styles.disclaimer}>
          <strong>{ui.disclaimer.title}</strong>
          {ui.disclaimer.body}
        </p>
        <span className={`${styles.footerMascot} ${styles.mascotWave}`}>
          <Mascot id="momo" size={40} title="もも（よりそいノートのマスコット）" />
        </span>
        <p className={styles.footerCopy}>{ui.disclaimer.copy}</p>
      </div>
    </footer>
  );
}
